import {TicketItemInSeriesVo} from '../../common/shared/api/nicolas/vo/TicketItemInSeriesVo.interface';
import {getTicketTitle} from '../../design-system/organisms/HistoryItem/getTicketTitle.function';
import {getTicketRefundInfo} from '../../domain/content/[seriesId]/util/getTicketRefundInfo';
import {TicketItemInSeries} from '../generated/types';
import {createSaleType} from './SaleType';
import {createTicketKind} from './TicketKind';
import {createTicketType} from './TicketType';

export function createTicketItemInSeries({
  uid,
  create_dt,
  ticket_expire_dt,
  sale_type,
  remain_count,
  inital_amount,
  ticket_type,
}: TicketItemInSeriesVo): TicketItemInSeries {
  return {
    uid,
    createDt: create_dt,
    ticketStatusText: getTicketRefundInfo({
      saleType: createSaleType(sale_type),
      ticketKind: createTicketKind(ticket_type),
      ticketExpireDt: ticket_expire_dt,
      remainCount: remain_count,
    }),
    saleType: createSaleType(sale_type),
    remainCount: remain_count,
    initialAmount: inital_amount,
    ticketType: createTicketType(ticket_type),
    ticketKind: createTicketKind(ticket_type),
    productType: getTicketTitle(ticket_type),
  };
}
